/*!
 *  (c)(r) 2008-2021 IT-Service Robert Frunzke
 */

import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';
import { mj_create_unique_id } from './util.js';
import { MCUnknown } from './media.unknown.js';

export let MCOther = function($,mj) {

	var media_class = 7;

	function createPreview_SWF( dtinfo, target, xopts ) {
		var md_trg = $(target),
			media_id = dtinfo.media_id,
			meta = dtinfo.meta,
			// <object> element
			md_movie = null,
			// original swf dimensions
			md_src_w = meta[200] ? parseInt(meta[200][0],10) : 640,
			md_src_h = meta[201] ? parseInt(meta[201][0],10) : 480,
			md_src_aspect = md_src_w / md_src_h,
			// previous display dimensions - used to avoid superfluous reloads
			md_prev_dsp_w = -1,
			md_prev_dsp_h = -1
			;
		function close_handler( e, unbind ) {
			if( md_movie ) {
				md_movie.remove();
				md_movie = null;
			}
			if( unbind ) md_trg.off('.MCOther');
		}
		function resize_handler(e,w,h) {
			var // viewport dimensions
				view_w = Math.max(10,w-10),
				view_h = Math.max(10,h-10),
				// display dimensions
				dsp_w = md_src_w,
				dsp_h = md_src_h
				;
			if( md_src_w>view_w || md_src_h>view_h ) {
				if( md_src_aspect > view_w/view_h ) {
					// set width to viewport width, adjust height
					dsp_w = view_w;
					dsp_h = Math.round( view_w / md_src_aspect );
				} else {
					// set height to viewport height, adjust width
					dsp_w = Math.round( view_h * md_src_aspect );
					dsp_h = view_h;
				}
			}
			var left=Math.round(5+0.5*(view_w-dsp_w)), top=Math.round(5+0.5*(view_h-dsp_h));
			if( md_movie && md_prev_dsp_w==dsp_w && md_prev_dsp_h==dsp_h ) {
				// re-center the movie and return
				md_movie.css( { left:left+'px', top:top+'px' } );
				return;
			}
			md_prev_dsp_w = dsp_w;
			md_prev_dsp_h = dsp_h;
			// remove previous movie instance
			close_handler(e,false);
			// create movie instance
			var flash_id = mj_create_unique_id('md-preview-swf-'),
				vq = !dtinfo.is_latest_version ? '?version='+encodeURIComponent(dtinfo.version) : '',
				flash_url = mj.webroot+'media/file/get/id/'+media_id+'.swf'+vq,
				flash_html = '<object id="'+flash_id+'" type="application/x-shockwave-flash" data="'+flash_url+'" width="'+dsp_w+'" height="'+dsp_h+'" style="position:absolute">'
								+'<param name="wmode" value="opaque" />'
								+'<param name="movie" value="'+flash_url+'" />'
								+'<param name="quality" value="high" />'
								+'<param name="menu" value="true" />'
								+'<param name="allowScriptAccess" value="never" />'
								+'<param name="allowFullScreen" value="true" />'
								+'<param name="play" value="true" />'
							+'</object>';
			md_movie = md_trg.children('.md-empty-canvas').css( { width:view_w+'px', height:view_h+'px' } ).html(flash_html)
				.children('#'+flash_id).css( { left:left+'px', top:top+'px'} );
		}
		md_trg
			.off('.MCOther')
			.html('<div class="md-empty-canvas"></div>')
			.on('mjsclose.MCOther',function(e) {
				close_handler(e,true);
			})
			.on('mjsresize.MCOther',resize_handler);
		resize_handler(null,md_trg.width(),md_trg.height());
	}

	return Object.assign( {}, MCUnknown, {
		createPreview: function( dtinfo, target, xopts ) {
			var meta = dtinfo.meta;
			if( dtinfo.r_download ) {
				var has_custom_preview = meta[10] && meta[10][0] > 0;
				if( !has_custom_preview ) {
					var src_format = meta[-2]&&meta[-2][0] ? meta[-2][0] : 'application/octet-stream';
					if( src_format==='application/x-shockwave-flash' ) return createPreview_SWF(dtinfo,target,xopts); // preview for SWF
				}
			}
			// preview for anything else
			return MCUnknown.createPreview(dtinfo,target,xopts);
		},
	} );
}(jQuery,mj); // namespace MCOther
